import styled from 'styled-components'

export const Section = styled.section`
  padding-right: 0;
  ${props =>
    props.isFullWidth &&
    `
    width: 100%;
    max-width: none;

  `}
`
